var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbuse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_7516)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1584 1.97363H2.63169C1.90798 1.97363 1.31586 2.56576 1.31586 3.28947V12.5003C1.31586 13.224 1.90798 13.8161 2.63169 13.8161H13.1584C13.8821 13.8161 14.4742 13.224 14.4742 12.5003V3.28947C14.4742 2.56576 13.8821 1.97363 13.1584 1.97363ZM13.1584 12.5003H2.63169V3.28947H13.1584V12.5003Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7702 6.85538L11.8359 5.92114L9.75034 8.00674L8.82268 7.0725L7.89502 8.00016L9.75034 9.86864L12.7702 6.85538Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5792 4.60522H3.28961V5.92106H6.5792V4.60522Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5792 7.23706H3.28961V8.55289H6.5792V7.23706Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5792 9.86865H3.28961V11.1845H6.5792V9.86865Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_7516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.79,
    height: 15.79,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbuse);
export default __webpack_public_path__ + "static/media/abuse.8a05cf14ccd494f10cd97744db833ea8.svg";
export { ForwardRef as ReactComponent };